import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Button, Typography } from '@material-ui/core';

import { useItemStyles } from './style';

type MenuItemProps = {
    icon?: IconProp,
    text: string,
    description?: string,
    onClick?: () => void,
};

MenuItem.defaultProps = {
    icon: null,
    description: '',
    onClick: () => {},
};

function MenuItem(props: MenuItemProps): React.ReactElement {
    const {
        icon,
        text,
        description,
        onClick,
    } = props;
    const classes = useItemStyles();

    return (
        <Button
            className={classes.item}
            onClick={onClick}
        >
            {icon ? (
                <Typography variant="h4">
                    <Icon className={classes.icon} icon={icon} fixedWidth />
                </Typography>
            ) : null}
            <div className={classes.center}>
                <span className={classes.text}>{text}</span>
                <span className={classes.description}>{description}</span>
            </div>
            <Icon icon={faChevronRight} fixedWidth />
        </Button>
    );
}

export { MenuItem };
